import { render, staticRenderFns } from "./FormInputText.vue?vue&type=template&id=28557129&scoped=true&"
import script from "./FormInputText.vue?vue&type=script&lang=ts&"
export * from "./FormInputText.vue?vue&type=script&lang=ts&"
import style0 from "./FormInputText.vue?vue&type=style&index=0&id=28557129&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28557129",
  null
  
)

export default component.exports